module.exports = __webpack_public_path__ + "static/media/opensocialSmall.5f8a968f.svg";